/* One column that fills the shell's body and scrolls inside itself. The shell's body is a twelve-column
   grid for the screens that have not moved over; this page takes the whole of it. */
.page {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: var(--gap);
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  /* The page is its own scroller, so it is also what positioned descendants belong to. A screen-reader-only
     caption or text is `position: absolute`; with a static scroller it was placed against the window and
     escaped the clip, so a long page made the document itself scroll (G-P10-04: /dashboards, the sources
     and coverage tabs). */
  position: relative;
}

.chart {
  flex: 0 0 auto;
  min-width: 0;
  padding: 12px 16px;
}

/* The table card takes what is left, never less than a few rows, and its grid scrolls inside it. (What squeezed a
   Scope 1 table to "two rows" under three charts was a 40px blank spacer row, not this minimum: G-Wviewer-25.) */
.tableCard {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 280px;
}

/* A `state` is not a grid: it has no scroller of its own and may be as long as a settings page. The
   card is as tall as what it holds (never less than the few rows above) and the page scrolls to the
   rest, so nothing is cut off by the clip below at a small window or a large zoom. */
.tableCard[data-state] {
  flex: 1 0 auto;
}

/* A page with cards after its table lets the table be as tall as its rows, to 70% of the window. */
.tableCard[data-fits-rows] {
  flex: 0 0 auto;
  min-height: 0;
  max-height: max(280px, 70vh);
}

/* Clipped at the card's lower corners only: the filter line above holds option lists that open
   downward over the table and must not be cut off. */
.body {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border-radius: 0 0 var(--radius-card) var(--radius-card);
}

.body > :first-child {
  flex: 1 1 auto;
  min-height: 0;
}

/* A failed read that sits *above* the table (a list of sites that could not be read, the invitations
   waiting) is a notice, not a pane. As the body's first child it took the rule above and was squeezed
   to a sliver by the grid beneath it, with its Try again button cut off - in the DOM and not on the
   screen (E2E P9, G-P9-18, -19, -20). It keeps the height of its own words. It comes after the rule it
   overrides: the two selectors weigh the same. */
.body > [data-testid="read-failed"] {
  flex: 0 0 auto;
}

/* **A sentence in the table card is a note with room round it** (G-Wviewer-17). A refusal ("An Admin or an
   Approver locks a period.") sat flush against the card's border in 12px type, and as the body's first child it
   took the rule above and stretched to a 330px blank band over the grid. A paragraph keeps the height of its
   own words, with the card's 16px gutter; the grid beneath it takes the rest. */
.body > p,
.body > p:first-child {
  flex: 0 0 auto;
  margin: 0;
  padding: 10px 16px;
  font-size: var(--t-dense);
  line-height: 1.5;
}

.body > p:not(:only-child) {
  border-bottom: 1px solid var(--line);
}

.body > p + * {
  flex: 1 1 auto;
  min-height: 0;
}

/* A card that holds one sentence (a place refused to this role) is as tall as the sentence and not a blank
   page under it. */
.tableCard[data-state]:has(> .body > p:only-child) {
  flex: 0 0 auto;
  min-height: 0;
}


